import React, { useState, useEffect } from 'react';
import {
  SsContainer,
  SsTitle,
  ScorecardWrap,
  ScorecardTitle,
  ScoreRowDiv,
  ScoreBox,
  BoxBg,
  TargetBar,
  BlackBar,
  ScoreTitleDiv,
  ScoreValueDiv,
  TargetDiffSpan,
} from './styles';
import { get } from 'global/lib/lodash';
import { getColorFromScore } from 'global/styles';
import { useLoaded } from 'global/hooks/useLoaded';

const TARGET_COLORS = { higher: '#2196F3', lower: '#f44336' };

const ScoreRow = (props) => {
  const { title, score, displayScore, goalScore, scorecardConfig } = props;

  let val = parseFloat(typeof score === 'string' ? score.replace('%', '') : score);
  let goalVal = goalScore != null ? parseFloat(typeof goalScore === 'string' ? goalScore.replace('%', '') : goalScore) : null;

  const hasGoal = goalVal != null && !isNaN(goalVal) && !isNaN(val);
  const diff = hasGoal ? goalVal - val : 0;
  const diffColor = diff >= 0 ? TARGET_COLORS.higher : TARGET_COLORS.lower;

  const formatDiff = (d) => {
    const displayPct = get(scorecardConfig, 'displayPercentage');
    const maxScore = get(scorecardConfig, 'maxScore', 100);
    const minScore = get(scorecardConfig, 'minScore', 0);
    let disp = displayPct ? d : d * ((maxScore - minScore) / 100);
    disp = parseFloat(disp.toFixed(2));
    const prefix = disp >= 0 ? '+' : '';
    return `${prefix}${disp}`;
  };

  return (
    <ScoreRowDiv>
      <ScoreTitleDiv>{title}</ScoreTitleDiv>
      <ScoreBox>
        <BoxBg style={{ width: `${val}%`, backgroundColor: getColorFromScore(val) }} />
        {hasGoal && (
          <BlackBar style={{ left: `calc(2px + ${val}%)` }} />
        )}
        {hasGoal && diff !== 0 && (
          <TargetBar
            style={{
              left: `calc(2px + ${Math.min(val, goalVal)}%)`,
              width: `${Math.abs(diff)}%`,
              backgroundColor: diffColor,
            }}
          />
        )}
      </ScoreBox>
      <ScoreValueDiv>
        {displayScore}
        {hasGoal && (
          <TargetDiffSpan style={{ color: diffColor }}>
            {formatDiff(diff)}
          </TargetDiffSpan>
        )}
      </ScoreValueDiv>
    </ScoreRowDiv>
  );
};

const ScoreCard = (props) => {
  const { assessment, scorecard, scores, scorecardIndex } = props;
  const [systems, setsystems] = useState([]);

  const scorecardConfig = get(scorecard, 'config');

  const { data, loading } = scores || {};

  const loadProcessed = async () => {
    if (!loading) {
      const s = (data && data[scorecard.id]) ? data[scorecard.id].filter((d) => d.depth < 2) : [];
      setsystems(s);
    }
  };

  useEffect(() => {
    loadProcessed();
  }, [data, loading]);

  return (
    <ScorecardWrap>
      <ScorecardTitle>{get(scorecard, 'name')}</ScorecardTitle>

      <ScoreRow title={`Overall`} score={get(systems, '0.value')} displayScore={get(systems, '0.displayScore')} goalScore={get(systems, '0.goal.value')} scorecardConfig={scorecardConfig} />

      {systems.filter((d) => d.depth === 1 && d.value !== null).map((sc, i) => (
        <ScoreRow key={i} title={sc.name} displayScore={sc.displayScore || sc.value} score={sc.value || sc.displayScore} goalScore={get(sc, 'goal.value')} scorecardConfig={scorecardConfig} />
      ))}
    </ScorecardWrap>
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const { assessment, canShowScores, scores } = props;

  const cards = get(assessment, 'data.scorecards', []);

  useLoaded(props, [!cards]);

  return !canShowScores ? null : (
    <SsContainer>
      <SsTitle>Scorecard Summary</SsTitle>

      {cards.map((card, i) => (
        <ScoreCard key={i} scorecard={card} scores={scores} scorecardIndex={i} assessment={assessment} />
      ))}
    </SsContainer>
  );
};
